import styled from 'styled-components';

export const ChatscreenFractalTheme = styled.div`
	height: 100vh;
	background: ${(props) => (props.screenSize > 500 ? '' : '#f5faff')};

	& > div {
		overflow: hidden;
		border-radius: ${(props) => (props.screenSize < 500 ? '' : '42px')};

		& > .conversation-holder {
			border-radius: ${(props) => (props.screenSize < 500 ? '' : '29px')};
			background: #f5faff;
			padding: 38px 60px;
			overflow: auto;
			overflow-x: hidden;
			// height: calc(100vh - 160px);
			height: calc(100vh - 149px);
			display: flex;
			flex-direction: column;
			&.mobile {
				padding: 11px 16px;
				// height: calc(100vh - 98px);
				height: calc(100vh - 92px);
			}
			&.tablet:not(.paddingInitial) {
				padding: 38px 30px;
			}
			margin-bottom: 12px;
		}
	}
	& > .close-svg-input-container {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: ${(props) => (props.screenSize > 500 ? '' : '0 15px')};
		&.formIsActive {
			display: none !important;
		}
		& > .close-svg-holder {
			border-radius: 50%;
			background: #fff;
			box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
			min-width: 37px;
			min-height: 36px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		& > .fractal-chat-input {
			width: 100%;

			& .MuiFormControl-root {
				align-items: center;
				max-width: unset;
				width: 100%;
				padding: 0 !important;
				& .MuiInputBase-root {
					width: 100%;
					padding: ${(props) =>
						props.screenSize > 500
							? '12px 24px'
							: props.chatInputValue
							? '3.5px'
							: '8px'};
					border-radius: 31.5px;
					height: ${(props) => (props.screenSize > 500 ? '60px' : '')};
					background: #fff;
					padding-right: ${(props) => (props.screenSize > 500 ? '8px' : '4px')};
					padding-left: ${(props) => (props.screenSize > 500 ? '' : '12px')};
					&:not(.Mui-focused, .Mui-disabled, .Mui-error):hover {
						.MuiOutlinedInput-notchedOutline {
							border-color: #43a1fe;
						}
					}

					&:not(.Mui-disabled, .Mui-error).Mui-focused {
						.MuiOutlinedInput-notchedOutline {
							border-color: #43a1fe;
						}
					}
				}
			}
		}
	}
`;
